import {Injectable} from '@angular/core';
import {UtilsService} from '../utils/utils.service';
import * as moment from 'moment';

export class MetaSemanaCurvaDiaria {
  dom: string;
  valorDom: number;
  seg: string;
  valorSeg: number;
  ter: string;
  valorTer: number;
  qua: string;
  valorQua: number;
  qui: string;
  valorQui: number;
  sex: string;
  valorSex: number;
  sab: string;
  valorSab: number;

  constructor(metaWeek?) {
    Object.assign(this, metaWeek);
  }
}

export class MetaDiaCurvaDiaria {
  data: string;
  valor: number;

  constructor(metaWeek?) {
    Object.assign(this, metaWeek);
  }
}

@Injectable()
export class MetaCurvaDiariaFactory {

  constructor(private _utils: UtilsService) {
  }

  getMetaCurvaDiariaDias(metaMes, dataInicial, dataFinal) {
   return this.calcMetaDias(metaMes, dataInicial, dataFinal);
  }

  getMetaCurvaDiariaSemana(week, rangeData, metaDias?) {
    const metaWeek = this.calcMetaWeek(week, rangeData, metaDias);
    return new MetaSemanaCurvaDiaria(metaWeek);
  }

  getMetaCurvaDiariaMes(meta, metaDias?) {
    const metaMes = this.calcMetaMes(meta.dataInicial, metaDias);
    return metaMes;
  }

  calcMetaDias(metaMes, dataInicial, dataFinal) {
    const metaDias = [];
    metaMes.map((metaSemana) => {
      for (const key in metaSemana) {
        if (metaSemana.hasOwnProperty(key)) {
          const metaDia = {};
          const diaSemana = key.split('valor')[1] ? key.split('valor')[1].toLowerCase() : null;
          if (diaSemana) {
            if (!this.checkDataDontBelongsMeta(metaSemana[diaSemana], dataInicial, dataFinal)) {
              metaDia['data'] = metaSemana[diaSemana];
              metaDia['valor'] = metaSemana[key];
              metaDias.push(metaDia);
            }
          }
        }
      }
    });
    return metaDias;
  }

  calcMetaWeek(week, rangeData, metaDias?) {
    const metaWeek = {};
    for (let index = 0; index < rangeData.length; index++) {
      const numberDayOfWeek = Number(moment(rangeData[index], 'DD/MM/YYYY').format('e'));
      let stringDayOfWeek = (moment(rangeData[index], 'DD/MM/YYYY').format('ddd')).toLowerCase();
      stringDayOfWeek = this._utils.removeAccents(stringDayOfWeek);
      if (index < 7 * week) {
        if (numberDayOfWeek === index - (7 * (week - 1))) {
          metaWeek[stringDayOfWeek] = rangeData[index];
          metaWeek[`valor${this._utils.capitalizeFirstLetter(stringDayOfWeek)}`] =
            metaDias ? this._utils.getPropObjFromArray(metaDias, 'valor', 'data', metaWeek[stringDayOfWeek]) : null;
        }
      } else {
        break;
      }
    }
    return metaWeek;
  }

  calcMetaMes(dataInicial, metaDias?) {
    moment.locale('pt-BR');
    const dataInicialStartWeek = moment(dataInicial).startOf('week');
    const dataFinal = moment(dataInicial).add(1, 'month').subtract(1, 'days').endOf('day');
    const dataFinalEndWeek = moment(dataFinal).endOf('week');
    const rangeData = this._utils.rangeArray(dataInicialStartWeek, dataFinalEndWeek, 'day', 'DD/MM/YYYY');
    const arrayWeeks = [];
    const sizeOfRows = Math.ceil(rangeData.length / 7);
    for (let week = 1; week <= sizeOfRows; week++) {
      const metaWeek = this.getMetaCurvaDiariaSemana(week, rangeData, metaDias);
      arrayWeeks.push(metaWeek);
    }
    return arrayWeeks;
  }

  checkDataDontBelongsMeta(data, dataInicial, dataFinal) {
    return (moment(data, 'DD/MM/YYYY', true).isValid() && moment(data, 'DD/MM/YYYY').isBefore(dataInicial, 'day')) ||
      (moment(data, 'DD/MM/YYYY', true).isValid() && moment(data, 'DD/MM/YYYY').isAfter(dataFinal, 'day'));
  }
}
